import { render } from "./AddAsset.vue?vue&type=template&id=2a593b70&scoped=true"
import script from "./AddAsset.vue?vue&type=script&lang=js"
export * from "./AddAsset.vue?vue&type=script&lang=js"

import "./AddAsset.vue?vue&type=style&index=0&id=2a593b70&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a593b70"]])

export default __exports__